export interface ApiPagination {
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export type SortOrder = 'asc' | 'desc';

export interface ApiMeta {
  pagination?: ApiPagination;
}

export interface PaginatedResponse<T> {
  data: T[];
  meta?: ApiMeta;
}

export interface AscResponse<T> {
  data: T;
  message?: string;
}

export interface RequestPagination {
  page?: number;
  pageSize?: number;
  start?: number;
  limit?: number;
}

export interface ICallback {
  onSuccess?: (res: unknown) => void;
  onError?: (err: unknown) => void;
  onFinally?: () => void;
}

export interface FileType {
  id: string;
  createdAt: string;
  updatedAt: string;
  key: string;
  bucket: string;
  location: string;
  fileName?: string;
  mimeType?: string;
  fileSize?: number;
}

export interface CommonType {
  id: string;
  createdAt: string;
  updatedAt: string;
}

export enum PER_PAGE {
  studentPage = 25,
  challengeFeedbackStudentList = 25,
  studentFeedbackSubmissions = 25,
  challengeListWithStats = 25,
  submissionListById = 25,
  importStudents = 25,
  importLogs = 25,
}

export interface CSVUploadResult {
  succesfullImports: number;
  totalCount: number;
  failedStudentArray: {
    name: string;
    email: string;
    batch?: string;
    importError?: string;
  }[];
}
